import { InnerBanner } from "container/InnerpageBanner/index";
import { Crumbs } from "molecules/Breadcrumbs";
import { SectionBorder } from "molecules/SectionBorder";
import { TitleHeading } from "molecules/TitleHeading";
import React, { useState } from "react";
import { useSelector, RootStateOrAny } from "react-redux";

import { FaAngleRight, FaAngleDown } from "react-icons/fa6";

export const Clients = () => {
  const {
    data: clientdata,
    loading,
    error,
  } = useSelector((state) => state.clientPage);
  const { data: dashboardData } = useSelector((state) => state.dashboard);

  console.log("clientsdata", clientdata);
  // const clientdata = [
  //   {
  //     id: 1,
  //     client_name: "CGI",
  //     category: "",
  //     image_path: "/media/home_slider/client_box.png",
  //   },
  //   {
  //     id: 2,
  //     client_name: "CGI",
  //     category: "ARC",
  //     image_path: "/media/home_slider/client_box-1.png",
  //   },
  //   {
  //     id: 3,
  //     client_name: "CGI",
  //     category: "ARC",
  //     image_path: "/media/home_slider/3_1.png",
  //   },
  //   {
  //     id: 4,
  //     client_name: "CGI",
  //     category: "ARC",
  //     image_path: "/media/home_slider/4_1.png",
  //   },
  //   {
  //     id: 1,
  //     client_name: "CGI",
  //     category: "",
  //     image_path: "/media/home_slider/client_box.png",
  //   },
  //   {
  //     id: 2,
  //     client_name: "CGI",
  //     category: "Banks",
  //     image_path: "/media/home_slider/client_box-1.png",
  //   },
  //   {
  //     id: 3,
  //     client_name: "CGI",
  //     category: "Banks",
  //     image_path: "/media/home_slider/3_1.png",
  //   },
  //   {
  //     id: 4,
  //     client_name: "CGI",
  //     category: "Banks",
  //     image_path: "/media/home_slider/4_1.png",
  //   },
  // ];

  const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  return (
    <div className="backgroundThm mobileContainer">
      <div className="container  pl-0 pr-0">
        <Crumbs />

        <InnerBanner
          bannertext={dashboardData?.client_page_description}
          bannerimg={dashboardData?.client_page_image}
          innertitle="Clients"
        />

        <section className="section-padding pt-0 pb-0 px-0">
          <div className="container pr-0 pl-0">
            <div className="lg:col-12 md:col-12 sm:col-12 p-0">
              <div
                className="lg:col-10 md:col-12 sm:col-12 py-4 pl-0"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                }}
              >
                <h4
                  className="fontEb font23 m-0"
                  style={{ fontSize: "23px !important" }}
                  dangerouslySetInnerHTML={{
                    __html: dashboardData?.client_page_description_2,
                  }}
                ></h4>
              </div>
              <SectionBorder />
              {clientdata?.map((cData, i) => {
                const isLastItem = i === clientdata.length - 1; // Check if it's the last item
                return (
                  <>
                    <div
                      className={`accordion-section ${
                        openSections[cData?.title] ? "pt-4" : "py-4"
                      } ${isLastItem ? "mb-3" : ""}`}
                    >
                      <div
                        className="accordion-header"
                        onClick={() => toggleSection(cData?.title)}
                      >
                        {cData?.title}
                        {openSections[cData?.title] ? (
                          <FaAngleDown />
                        ) : (
                          <FaAngleRight />
                        )}
                      </div>
                      {openSections[cData?.title] && (
                        <div
                          className="grid mt-3  mb-2 p-0 pr-0 align-items-center"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          {cData?.images?.map((item, index) => (
                            <div
                              className="mb-4"
                              style={{ display: "flex" }}
                              key={index}
                            >
                              <div className="card  ">
                                <img
                                  src={item.image}
                                  alt=""
                                  className="img-fluid clientsLogoImg "
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <SectionBorder />
                  </>
                );
              })}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
